import React from 'react';
import PropTypes from 'prop-types';

module.exports = React.createClass({
	render : function() {
		return this.props.children;
	}
});


// WEBPACK FOOTER //
// ./src/browser/components/posts/postsContainer.js